"use client";
import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import EastIcon from "@mui/icons-material/East";
import { useRouter } from "next/navigation";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const topTrustItems = [
  "ctaBanner.trust1",
  "ctaBanner.trust2",
  "ctaBanner.trust3",
  "ctaBanner.trust4",
];

const bottomTrustItem = "ctaBanner.trust5";

const CtaBanner = () => {
  const { t, i18n } = useTranslation();
  const router = useRouter();
  const isArabic = i18n.language === "ar";

  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #F9FAFB 0%, #FFFFFF 100%)",
        py: { xs: 5, sm: 6, md: 7 },
        direction: isArabic ? "rtl" : "ltr",
      }}
    >
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* ── HEADING ── */}
          <Typography
            component="h2"
            sx={{
              fontFamily: "var(--font-plusjakarta), sans-serif",
              fontWeight: 800,
              fontSize: { xs: "1.5rem", sm: "2rem", md: "2.8rem" },
              color: "#0b132a",
              lineHeight: 1.25,
              letterSpacing: "-0.01em",
              mb: { xs: 2, sm: 2.5, md: 3 },
              maxWidth: 780,
              mt: "3%",
              px: { xs: 1, sm: 2, md: 0 },
              textAlign: isArabic ? "right" : "center",
            }}
          >
            {t("ctaBanner.heading1")}
            {/* ── fix: xs/sm par br hide karo ── */}
            <Box component="br" sx={{ display: { xs: "none", md: "block" } }} />
            {t("ctaBanner.heading2")}
          </Typography>

          {/* ── DESCRIPTION CONTENT BLOCK ── */}
          <Box
            sx={{
              mb: { xs: 3, sm: 3.5, md: 4 },
              px: { xs: 1, sm: 2, md: 0 },
            }}
          >
            <Typography
              sx={{
                fontFamily: "var(--font-outfit), sans-serif",
                fontSize: { xs: "0.82rem", sm: "0.88rem", md: "1rem" },
                color: "#364153",
                lineHeight: 1.6,
                mb: 1.5,
                // ── fix: xs par 64% bohot tight tha ──
                maxWidth: { xs: "100%", sm: "80%", md: "64%" },
                textAlign: isArabic ? "right" : "center",
                mx: "auto",
              }}
            >
              {t("ctaBanner.desc1")}
            </Typography>
          </Box>

          {/* <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: { xs: 1.5, sm: 2, md: 2.5 },
              mb: { xs: 3, sm: 3.5, md: 4 },
            }}
          >
            {[
              "ctaBanner.aboveBtn1",
              "ctaBanner.aboveBtn2",
              "ctaBanner.aboveBtn3",
            ].map((key) => (
              <Box
                key={key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.8,
                  backgroundColor: "#fff",
                  border: "1px solid #E5E7EB",
                  borderRadius: "50px",
                  px: { xs: 1.5, sm: 2, md: 2.5 },
                  py: { xs: 0.6, sm: 0.75, md: 0.9 },
                }}
              >
                <Box
                  component="img"
                  src="https://getgeek-website-assets.b-cdn.net/icon.webp"
                  alt="check"
                  sx={{
                    width: { xs: "14px", sm: "16px", md: "12px" },
                    height: { xs: "14px", sm: "16px", md: "12px" },
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  sx={{
                    fontFamily: "var(--font-outfit), sans-serif",
                    fontSize: { xs: "0.75rem", sm: "0.82rem", md: "0.88rem" },
                    color: "#475569",
                    whiteSpace: "nowrap",
                  }}
                >
                  {t(key)}
                </Typography>
              </Box>
            ))}
          </Box> */}

          {/* ── PILL CTA BUTTON ── */}
          <Button
            id="btn-nine"
            // onClick={() => {
            //   const el = document.getElementById("book-demo-section");
            //   if (el) el.scrollIntoView({ behavior: "smooth" });
            // }}
             onClick={() => {
  window.dispatchEvent(new Event("open-book-demo-modal"));
}}
            endIcon={
              <ArrowForwardIcon
                sx={{
                  fontSize: "1.3rem !important",
                  ml: 0.5,
                  mr:1,
                  transform: isArabic ? "rotate(180deg)" : "none",
                  mt: isArabic ? "10%" : "0",
                }}
              />
            }
            sx={{
              background: "#7C3AED",
              color: "#fff",
              fontFamily: "var(--font-outfit), sans-serif",
              fontWeight: 600,
              fontSize: { xs: "0.78rem", sm: "0.82rem", md: "1rem" },
              px: { xs: 3, sm: 3.5, md: 5 },
              py: { xs: 1.3, sm: 1.5, md: 1.8 },
              borderRadius: "50px",
              textTransform: "none",
              mb: { xs: 4, sm: 5, md: 4 },
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                background: "#7C3AED",
                transform: "scale(1.05)",
              },
              "&:active": { transform: "translateY(0)" },
            }}
          >
            {t("ctaBanner.cta")}
          </Button>

          {/* ── DIVIDER ── */}
          <Box
            sx={{
              width: "100%",
              maxWidth: 1100,
              height: "1px",
              backgroundColor: "#f1f5f9",
              mb: { xs: 3, sm: 3.5, md: 4 },
            }}
          />

          {/* ── TRUST LAYOUT LIST ── */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: { xs: 1.5, sm: 2 },
              width: "100%",
              pb: { xs: 1, sm: 0 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                columnGap: { xs: 1.5, sm: 2, md: 2.5 },
                rowGap: { xs: 1.2, sm: 1.5 },
                width: "100%",
                pb: { xs: 1, sm: 0 },
              }}
            >
              {[...topTrustItems, bottomTrustItem].map((key) => (
                <Box
                  key={key}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.8,
                    backgroundColor: "#fff",
                    borderRadius: "50px",
                    px: { xs: 1.5, sm: 2, md: 2.5 },
                    py: { xs: 0.6, sm: 0.75, md: 0.9 },
                    border: "1px solid #E5E7EB",
                    borderRadius: "50px",
                  }}
                >
                  <Box
                    component="img"
                    src="https://getgeek-website-assets.b-cdn.net/icon.webp"
                    alt="check"
                    sx={{
                      width: { xs: "14px", sm: "16px", md: "12px" },
                      height: { xs: "14px", sm: "16px", md: "12px" },
                      objectFit: "contain",
                      flexShrink: 0,
                    }}
                  />
                  <Typography
                    sx={{
                      fontFamily: "var(--font-outfit), sans-serif",
                      fontSize: { xs: "0.72rem", sm: "0.78rem", md: "0.84rem" },
                      color: "#475569",
                      whiteSpace: "nowrap",
                      fontWeight: 600,
                    }}
                  >
                    {t(key)}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default CtaBanner;
